import { FullPageScreen } from "@/lib/Components/Screens/FullPageScreen";
import { EmailEventTable } from "@/app/EmailEvents/Components/EmailEventTable";

export function EmailEventTableScreen() {
  return (
    <FullPageScreen>
      <EmailEventTable />
    </FullPageScreen>
  );
}
